const colors = require("../../src/styles/colors");

module.exports = {
  siteTitle: "QAsplat - the sound of messy software being made", // <title>
  shortSiteTitle: "QAsplat", // <title> ending for posts and pages
  siteDescription: "QAsplat is a blog about software testing and development. Sometimes it's messy but that's just part of the fun.",
  siteUrl: "https://qasplat.com",
  pathPrefix: "",
  siteImage: "preview-image.png",
  siteLanguage: "en",
  // author
  authorName: "Michael Cherry-Leigh",
  authorTwitterAccount: "QAsplat",
  // info
  infoTitle: "QAsplat",
  infoTitleNote: "The sound of messy software being made",
  // manifest.json
  manifestName: "QAsplat is a blog mostly about software testing and development",
  manifestShortName: "QAsplat", // max 12 characters
  manifestStartUrl: "/",
  manifestBackgroundColor: colors.background,
  manifestThemeColor: colors.background,
  manifestDisplay: "standalone",
  // contact
  contactEmail: "mcl@qasplat.com",
  // social
  authorSocialLinks: [
    { name: "github", url: "https://github.com/mcherryleigh" },
    { name: "twitter", url: "https://twitter.com/qasplat" }
  ]
};



// WEBPACK FOOTER //
// ./content/meta/config.js